import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { NProgress } from '@tanem/react-nprogress';
import { CSSTransition } from 'react-transition-group';
import { connect } from 'react-redux';
import { ViewerbaseDragDropContext } from 'react-viewerbase';
import LoginRouting from './login/LoginRouting.js';
import RegisterRouting from './register/RegisterRouting.js';
import VerifyRouting from './verify/VerifyRouting.js';
import UploadRouting from './upload/UploadRouting.js';
import CallbackPage from './routes/CallbackPage.js';
import NotFound from './routes/NotFound.js';
import { Bar, Container } from './components/LoadingBar/';
import './OHIFStandaloneViewer.css';
import './variables.css';
import './theme-tide.css';
import AiViewerRouting from './routes/AiViewerRouting';
import ViewerRouting from './routes/ViewerRouting.js';
import ChartsRouting from './charts/ChartsRouting';
import DataRouting from './data/DataRouting';
import DataDarkRouting from './dataDark/DataDarkRouting';
import UserManagerRouting from './userManager/UserManagerRouting';
import RoleManagerRouting from './roleManager/RoleManagerRouting';
import InstitutionManagerRouting from './institutionManager/InstitutionManagerRouting';
import DemoRouting from './demo/DemoRouting';
import ReportRouting from './report/ReportRouting';

import ReportListRouting from './report/ReportListRouting';
import PreviewReportRouting from './previewReport/PreviewReportRouting';
import ReviewRouting from './review/ReviewRouting';
import KnowledgeRouting from './knowledge/KnowledgeRouting';
import PreviewRouting from './report/PreviewRouting';
import ChartReportRouting from './charts/ReportRouting';
import SmartEyeDataRouting from './smartEye/DataRouting';
import AIProductionRouting from './smartEye/ProductionRouting';
import LogRouting from './operationLog/LogRouting';
import FeedbackRouting from './feedback/FeedbackRouting';
import IntelligentScreeningRouting from './intelligentScreening/IntelligentScreeningRouting';
import IntelligentReviewRouting from './review/IntelligentReviewRouting.js';
import UserBehaviorRouting from './userManager/UserBehaviorRouting.js';
import LungHelpRouting from './forHelps/LungHelpRouting.js';
import ScreeningHelpRouting from './forHelps/ScreeningHelpRouting.js';
import WorklistHelpRouting from './forHelps/WorklistHelpRouting.js';
import DataReportRouting from './data/ReportRouting.js';
import ThirdRouting from './third/ThirdRouting';

// CT报告
import CTReportListRouting from './CTReport/ReportListRouting';
import CTReportRouting from './CTReport/ReportRouting.js';
import CTPreviewRouting from './CTReport/PreviewRouting.js';
import CTViewerRouting from './routes/CTViewerRouting';

import TBReportRouting from './print/TBReportRouting';

const reload = () => window.location.reload();

class OHIFStandaloneViewer extends Component {
  state = {
    isLoading: false,
  };

  static propTypes = {
    history: PropTypes.object.isRequired,
    user: PropTypes.object,
    setContext: PropTypes.func,
    userManager: PropTypes.object,
    location: PropTypes.object,
  };

  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      if (this.props.setContext) {
        this.props.setContext(window.location.pathname);
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { user, userManager } = this.props;

    const userNotLoggedIn = userManager && (!user || user.expired);
    if (userNotLoggedIn) {
      const pathname = this.props.location.pathname;

      if (pathname !== '/callback') {
        sessionStorage.setItem('ohif-redirect-to', pathname);
      }

      return (
        <Switch>
          <Route exact path="/silent-refresh.html" onEnter={reload} />
          <Route exact path="/logout-redirect.html" onEnter={reload} />
          <Route
            path="/callback"
            render={() => <CallbackPage userManager={userManager} />}
          />
          <Route
            component={() => {
              userManager.signinRedirect();

              return null;
            }}
          />
        </Switch>
      );
    }

    /**
     * Note: this approach for routing is caused by the conflict between
     * react-transition-group and react-router's <Switch> component.
     *
     * See http://reactcommunity.org/react-transition-group/with-react-router/
     */
    const routes = [
      { path: '/heatmap', Component: AiViewerRouting },
      { path: '/login', Component: LoginRouting },
      { path: '/register', Component: RegisterRouting },
      { path: '/verify', Component: VerifyRouting },
      { path: '/upload/:id', Component: UploadRouting },
      { path: '/upload/heatmap', Component: UploadRouting },
      { path: '/', Component: LoginRouting },
      { path: '/charts/:id', Component: ChartsRouting },
      { path: '/statistical/report', Component: ChartReportRouting },
      { path: '/data/:id', Component: DataRouting },
      { path: '/report/data', Component: DataReportRouting },
      { path: '/datadark', Component: DataDarkRouting },
      { path: '/usermanager', Component: UserManagerRouting },
      { path: '/rolemanager', Component: RoleManagerRouting },
      { path: '/institutionmanager', Component: InstitutionManagerRouting },
      { path: '/demo', Component: DemoRouting },
      { path: '/third/platform', Component: ThirdRouting },
      {
        path: '/report/:diagId/:state/:applicationId',
        Component: ReportRouting,
      },
      { path: '/reportlist', Component: ReportListRouting },
      {
        path: '/previewreport/:dicomId/:uploadType',
        Component: PreviewReportRouting,
      },
      { path: '/reviewlist', Component: ReviewRouting },
      { path: '/report/preview/:applicationId', Component: PreviewRouting },
      { path: '/knowledgebase', Component: KnowledgeRouting },
      // {
      // 	path: '/viewer/study/:studyInstanceUids/series/:seriesInstanceUids/instances/:sopInstanceUids',
      // 	Component: ViewerRouting
      // },
      { path: '/viewer/study/:studyInstanceUids', Component: ViewerRouting },
      { path: '/smarteye/data', Component: SmartEyeDataRouting },
      { path: '/smarteye/aiproduction', Component: AIProductionRouting },
      { path: '/operationlog', Component: LogRouting },
      { path: '/feedbacklist', Component: FeedbackRouting },
      { path: '/intelligentscreening', Component: IntelligentScreeningRouting },
      {
        path: '/review/intelligentscreening',
        Component: IntelligentReviewRouting,
      },
      { path: '/userbehavior', Component: UserBehaviorRouting },
      { path: '/lunghelp', Component: LungHelpRouting },
      { path: '/screeninghelp', Component: ScreeningHelpRouting },
      { path: '/worklisthelp', Component: WorklistHelpRouting },
      // CT报告
      { path: '/report-list/ct', Component: CTReportListRouting },
      {
        path: '/report/ct/:diagId/:state/:applicationId',
        Component: CTReportRouting,
      },
      {
        path: '/report/preview-ct/:applicationId',
        Component: CTPreviewRouting,
      },
      {
        path: '/viewer/ct/study/:studyInstanceUids/:diagId',
        Component: CTViewerRouting,
      },
      { path: '/tb/report/:token', Component: TBReportRouting },
    ];

    const currentPath = this.props.location.pathname;
    const noMatchingRoutes = !routes.find(r =>
      matchPath(currentPath, { path: r.path, exact: true })
    );

    return (
      <>
        <NProgress isAnimating={this.state.isLoading}>
          {({ isFinished, progress, animationDuration }) => (
            <Container
              isFinished={isFinished}
              animationDuration={animationDuration}
            >
              <Bar progress={progress} animationDuration={animationDuration} />
            </Container>
          )}
        </NProgress>
        <Route exact path="/silent-refresh.html" onEnter={reload} />
        <Route exact path="/logout-redirect.html" onEnter={reload} />
        {!noMatchingRoutes &&
          routes.map(({ path, Component }) => (
            <Route key={path} exact path={path}>
              {({ match }) => (
                <CSSTransition
                  in={match !== null}
                  timeout={300}
                  classNames="fade"
                  unmountOnExit
                  onEnter={() => {
                    this.setState({ isLoading: true });
                  }}
                  onEntered={() => {
                    this.setState({ isLoading: false });
                  }}
                >
                  {match === null ? <></> : <Component match={match} />}
                </CSSTransition>
              )}
            </Route>
          ))}
        {noMatchingRoutes && <NotFound />}
      </>
    );
  }
}

//获取token
// getToken();
// async function getToken() {
//   const init = {
//     method: 'GET',
//   };

//   const res = await fetch(`/ai-web/auth/getToken`, init);
//   if (res.status === 200) {
//     const result = await res.json();
//     let token = result.data.access_token;
//     window.localStorage.setItem('access_token', token);
//   }
// }

const mapStateToProps = state => {
  return {
    user: state.oidc.user,
  };
};

const ConnectedOHIFStandaloneViewer = connect(
  mapStateToProps,
  null
)(OHIFStandaloneViewer);

export default ViewerbaseDragDropContext(
  withRouter(ConnectedOHIFStandaloneViewer)
);
